import React from 'react';

export default function QuestionCard({
  question,
  selected,
  onSelect,
  mode = 'practice',
  disabled = false,
}) {
  const options = question.options || [];
  const isExam = mode === 'exam';

  return (
    <div className="bg-bg-card rounded-r-xl border border-border-soft">
      <div className="px-sp-6 py-sp-5">
        {question.scenario && (
          <div className="bg-bg-surface rounded-r-md px-sp-4 py-sp-3 mb-sp-4">
            <p className="text-sm text-text-primary leading-relaxed whitespace-pre-wrap">
              {question.scenario}
            </p>
          </div>
        )}
        <p className="text-[15px] font-semibold text-text-primary mb-sp-4">{question.stem}</p>
        <div className="flex flex-col gap-sp-2">
          {options.map((opt) => {
            const letter = opt.letter;
            const isSelected = selected === letter;
            const baseCls =
              'flex items-center gap-sp-3 px-sp-4 py-sp-3 rounded-r-md cursor-pointer transition-colors text-left';
            const stateCls = isSelected
              ? 'border-2 border-accent bg-blue-lightest'
              : 'border border-border-soft hover:border-border-medium';
            return (
              <button
                key={letter}
                type="button"
                onClick={() => {
                  if (disabled) return;
                  onSelect(letter);
                }}
                disabled={disabled}
                className={`${baseCls} ${stateCls} ${disabled ? 'cursor-not-allowed opacity-70' : ''}`}
              >
                <span
                  className={`w-[26px] h-[26px] rounded-full border-2 flex items-center justify-center text-xs font-semibold flex-shrink-0 ${
                    isSelected
                      ? 'bg-accent border-accent text-white'
                      : 'border-border-soft text-text-muted'
                  }`}
                >
                  {letter}
                </span>
                <p className="text-sm text-text-primary leading-relaxed">{opt.text}</p>
              </button>
            );
          })}
        </div>
        {/* Exam mode has no submit button — navigation is via Previous/Next in the session header */}
        {!isExam && (
          <p className="text-xs text-text-muted mt-sp-4">Click an option to submit your answer.</p>
        )}
      </div>
    </div>
  );
}
